<template>
    <v-container class="mb-6">

        <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>

        <div class="mb-2">
            {{ date }}
        </div>
        <v-card class="mb-4" :loading="loading">
            <v-card-title>
                {{$t('Detalles del pedido')}} #{{ dataService.number }}
                <small class="grey--text ml-3">{{$t('IP del cliente')}}: {{ dataService.ip_address }}</small>
            </v-card-title>
            <v-card-text>
                <v-row>
                    <v-col cols="12" sm="6">
                        <div class="text-h6">{{$t('Datos cliente')}}</div>
                        <v-divider class="mt-1 mb-2"></v-divider>
                        <div>
                            <strong>{{$t('Nombre')}}: </strong> {{ dataService.full_name }}
                            <br>
                            <strong>{{$t('Celular')}}: </strong> <a :href="`https://api.whatsapp.com/send?phone=591${dataService.phone_number}`" target="_blank">
                                {{ dataService.phone_number }}
                            </a>
                            <br>
                            <strong>{{$t('Fecha')}}: </strong> {{ date }}
                            <br>
                            <strong>{{$t('Hora')}}: </strong> {{ dataService.time }}
                            <br>
                            <strong>{{$t('Dato extra')}}: </strong> {{ dataService.extra }}
                        </div>
                    </v-col>
                    <v-col cols="12" sm="6">
                        <div class="text-h6">{{$t('Servicio')}}</div>
                        <v-divider class="mt-1 mb-2"></v-divider>
                        <div v-if="dataService.product">
                            <div class="text-h6">{{ dataService.product.name }}</div>
                            <div v-html="dataService.product.description"></div>
                        </div>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>

        <!-- overlay -->
        <v-overlay :value="overlay" opacity=".9" z-index="10">
            <v-progress-circular
                indeterminate
                size="64"
                color="primary"
            ></v-progress-circular>
        </v-overlay>
        <!-- end overlay -->

    </v-container>
</template>
<script>
export default {
    data() {
        return {
            overlay: false,
            loading: false,
            breadcrumbs: [
                {
                    text: 'Rservas',
                    disabled: false,
                    href: '/admin/reservations',
                },
                {
                    text: 'Pedido',
                    disabled: true,
                    href: '',
                }
            ],
            // data
            dataService: {},
            date: null,
        }
    },
    props: ['order', 'money'],
    mounted() {
        this.getSingleProduct()
    },
    methods: {
        /**
         * Single product
         */
        async getSingleProduct () {
            this.overlay = true
            await axios.post(`/admin/single-reservation/${this.order}`, {})
            .then(response => {
                // console.log(response)
                this.dataService = response.data

                const d = new Date(response.data.day)
                this.date = (d.getDate()+1) +'-'+ (d.getMonth()+1) +'-'+ d.getFullYear()

                this.overlay = false
            })
            .catch(error => {
                // console.log(error)
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert(this.$t('Error con el servidor, por favor vuelva a intentarlo más tarde.'));
                }
                this.overlay = false
            })
        },
    },
}
</script>
